import {createSelector} from 'reselect';
import {getSettings} from '../selectors';
import getPrivacyConsentFromPrivacyGroup from './getPrivacyConsentFromPrivacyGroup';

export default createSelector(
  [getSettings],
  settings => !!settings?.rokt_placement?.enabled,
);
